import {Global, css} from '@emotion/core'
import React from 'react'

const TermsPage = () => {
    return (
        <div
            className="terms-main"
            css={css`
                max-width: 900px;
                margin: 0 auto;
                padding: 15px 10px 150px;
                line-height: 20px;
                font-family: Arial, sans-serif;
                h1,
                h2 {
                    font-size: 18px;
                }
                h2 {
                    font-style: italic;
                }
                p {
                    font-size: 14px;
                }
            `}
        >
            <Global
                styles={css`
                    html,
                    body {
                        background: #fff !important;
                    }
                `}
            />
            <h1
                className="title"
                css={css`
                    text-align: center;
                `}
            >
                STARTPAGE TERMS OF USE
            </h1>
            <p className="intro" css={css``}>
                PLEASE READ THESE TERMS OF USE (“TERMS”) CAREFULLY BEFORE USING OUR SERVICES, WHICH ARE OWNED AND
                OPERATED BY SURFBOARD HOLDING BV, A PRIVATE LIMITED COMPANY ORGANIZED IN THE NETHERLANDS (“STARTPAGE”,
                “WE”, “US”, OR “OUR”). THESE TERMS SET FORTH THE LEGALLY BINDING TERMS AND CONDITIONS REGARDING YOUR USE
                OF THE STARTPAGE WEBSITES (INCLUDING WWW.STARTPAGE.COM AND AI.STARTPAGE.COM), PRIVATE SEARCH ENGINE,
                STARTPAGE PRIVATEAI, MOBILE APPS, AND ALL RELATED SERVICES, INCLUDING, WITHOUT LIMITATION, ALL WEBSITES,
                SEARCH RESULTS, OUTPUTS, MOBILE APPS, SOFTWARE, FEATURES, FUNCTIONALITY, CONTENT, PRODUCTS, OR OTHER
                SERVICES OFFERED FROM TIME TO TIME BY STARTPAGE IN CONNECTION WITH YOUR USE OF THE SERVICES
                (COLLECTIVELY, “SERVICES”). BY USING OUR SERVICES IN ANY MANNER, YOU AGREE TO BE BOUND BY THESE TERMS.
            </p>

            <h2>By Using Our Services, You Are Agreeing to these Terms</h2>
            <p>
                We offer our Services to you subject to your acceptance of these Terms without modification and all
                other guidelines, policies or procedures that we may publish or distribute from time to time related to
                our Services. In addition, some of the features and functionality that we offer through our Services may
                be subject to additional terms and conditions that we publish or distribute from time to time; your use
                of those features and functionality will be subject to those additional terms and conditions, which are
                incorporated into these Terms by this reference. <br /> <br />
                We may refuse to offer our Services to any person or entity and change our eligibility criteria at any
                time. This provision is void where prohibited by law, and your corresponding right to access and use our
                Services is deemed revoked in those jurisdictions.
            </p>

            <h2>We May Modify these Terms from Time to Time</h2>
            <p>
                We reserve the right to modify these Terms, or change, suspend, or discontinue our Services (including
                the availability of any feature, functionality, or content) at any time by updating these Terms and
                publishing or distributing these Terms through the Services. We may also impose limits on certain
                features, functionality and services, or restrict your access to parts or all of our Services, without
                further notice or liability. It is your responsibility to check these Terms periodically for changes or
                updates from time to time. Your continued use of our Services following the posting of any changes to
                these Terms constitutes your acceptance of those changes.
            </p>

            <h2>Our Other Policies</h2>
            <p>
                For information about how we process data and personal information, please review our Privacy Policy at{' '}
                <a href="https://www.startpage.com/en/privacy-policy" target="_blank" rel="noreferrer noopener">
                    https://www.startpage.com/en/privacy-policy
                </a>
                .
            </p>

            <h2>Restrictions on How Our Services Are Used</h2>
            <p>
                As a condition of your use, you promise not to use our Services for any purpose that is prohibited or
                otherwise restricted by these Terms or any applicable law, regulation, statute, directive, or rule
                (collectively, “Laws”). For the purposes of these Terms, the term “Content” includes, without
                limitation, any information, data, search results, text, photographs, videos, software, scripts,
                graphics, and interactive features generated, provided, or otherwise made accessible on or through our
                Services. For example, you will not (and will not permit any third party to) take any action (including
                by contributing any Content) that (i) constitutes a violation of any applicable Law; (ii) infringes any
                intellectual property or other right of any other person or entity; (iii) impersonates any person or
                entity; (iv) is threatening, abusive, harassing, defamatory, libelous, deceptive, fraudulent, invasive
                of another’s privacy, tortious, obscene, offensive, or profane; (v) constitutes unauthorized or
                unsolicited advertising, junk or bulk e-mail; or (vi) contains software viruses or any other similar
                malicious or nefarious computer codes, files, or programs.
                <br /> <br />
                In addition, you will not (directly or indirectly) (i) take any action that imposes or may impose an
                unreasonable or disproportionately large load on our (or our third-party providers’) infrastructure;
                (ii) interfere or attempt to interfere with the proper working of any of our Services or any activities
                conducted on our Services; (iii) bypass any measures we may use to prevent or restrict access to all or
                any part of our Services; or (iv) use any robot, spider, search/retrieval application, or other
                automated device, process or means to access, retrieve, copy, scrape, or index any portion of our
                Services or Content.
            </p>

            <h2>Trademarks and Other Intellectual Property Rights</h2>
            <p>
                All logos, marks and designations displayed on our Services are the trademarks or registered trademarks
                of us or our licensors. All other trademarks mentioned in our Services are the property of their
                respective owners. The trademarks and logos displayed in our Services may not be used without prior
                written consent from us or their respective owners. You may not remove or alter any trademark or logo,
                copyright or other proprietary notice in the Mobile Apps (and any related Services). Portions, features
                and/or functionality of our Services may be protected under patent applications or patents.
            </p>

            <h2>Third-party Sites and Content</h2>
            <p>
                Our Services may contain links to other websites or third-party providers (“Third-party Providers”), or
                include search results, photographs, graphics, pictures, text, information, videos, audio, applications,
                software, advertisements, and other content or items belonging to or originating from third parties
                (“Third-party Content”). We have no control over and bear no responsibility for Third-party Providers or
                Third-party Content. Linking to any Third-party Providers or inclusion of any Third-party Content does
                not imply our approval or endorsement.
            </p>

            <h2>Terminating Your Access to Our Services</h2>
            <p>
                We may terminate your access to all or any part of our Services at any time if you do not comply with
                these Terms. Further, we may terminate our Services for any reason and at any time without notice. Upon
                any termination, all rights and licenses granted to you in these Terms will immediately terminate, but
                all provisions which by their nature should survive termination will survive such termination,
                including, without limitation, warranty disclaimers, indemnity and limitations of liability.
            </p>

            <h2>Disclaimer</h2>
            <p>
                Our Services, and the Content published on our Services could include inaccuracies, typographical errors
                or other errors. We make no commitment, however, to update what is contained on our Services.
                Furthermore, we reserve the right to temporarily, or permanently, modify, alter, discontinue or delete
                the same without prior notice.
                <br />
                <br />
                You should not rely upon opinions expressed or information on our Services when making medical,
                business, financial, personal or other decisions. Furthermore, we do not endorse the opinions of third
                parties expressed on this Web site or on linked Web sites.
                <br />
                <br />
                ALL USE OF OUR SERVICES (INCLUDING, WITHOUT LIMITATION, ANY CONTENT AVAILABLE OR ACCESSED THROUGH OUR
                SERVICES) IS UNDERTAKEN ENTIRELY AT YOUR OWN RISK. OUR SERVICES (INCLUDING, WITHOUT LIMITATION, MOBILE
                APPS, WEBSITES AND ANY CONTENT) ARE PROVIDED “AS IS” AND “AS AVAILABLE”, AND ARE WITHOUT WARRANTY OF ANY
                KIND, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF TITLE,
                NON-INFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, AND ANY WARRANTIES IMPLIED BY
                ANY COURSE OF PERFORMANCE OR USAGE OF TRADE, ALL OF WHICH ARE EXPRESSLY DISCLAIMED. SOME JURISDICTIONS
                DO NOT ALLOW LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY LASTS, SO THE ABOVE LIMITATIONS MAY NOT APPLY
                TO YOU.
            </p>

            <h2>Indemnification</h2>
            <p>
                You shall defend, indemnify, and hold harmless us, our affiliates and each of our, and our affiliates’
                employees, contractors, agents, directors, officers, suppliers, partners, licensors and representatives
                from all liabilities, losses, claims, and expenses, including reasonable attorneys’ fees, that arise
                from or relate to (i) your use or misuse of, or access to, our Services; or (ii) your violation of these
                Terms or any applicable Law, contract, policy, regulation or other obligation. We reserve the right to
                assume the exclusive defense and control of any matter otherwise subject to indemnification by you, in
                which event you will assist and cooperate with us in connection therewith.
            </p>

            <h2>Limitation of Liability</h2>
            <p>
                IN NO EVENT SHALL WE, OUR AFFILIATES, AND EACH OF OUR, AND OUR AFFILIATES’ EMPLOYEES, CONTRACTORS,
                AGENTS, DIRECTORS, OFFICERS, SUPPLIERS, PARTNERS, LICENSORS OR REPRESENTATIVES, BE LIABLE UNDER
                CONTRACT, TORT, STRICT LIABILITY, NEGLIGENCE OR ANY OTHER LEGAL OR EQUITABLE THEORY WITH RESPECT TO OUR
                SERVICES (I) FOR ANY LOST PROFITS, DATA LOSS, COST OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, OR
                SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES OF ANY KIND WHATSOEVER, OR SUBSTITUTE
                GOODS OR SERVICES; (II) FOR YOUR RELIANCE ON OUR SERVICES; OR (III) FOR ANY DIRECT DAMAGES IN EXCESS (IN
                THE AGGREGATE) OF THE FEES PAID BY YOU (IF ANY) FOR YOUR USE OF OUR SERVICES, OR, IF GREATER, $1 USD.
                SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO
                THE ABOVE LIMITATIONS AND EXCLUSIONS MAY NOT APPLY TO YOU.
            </p>

            <h2>Mobile Apps</h2>
            <p>
                We provide the executable code version of the Mobile Apps under the additional terms in this section. In
                addition, source code for parts of the Mobile Apps may be available for use under open-source licenses
                and accessible by GitHub. Nothing in these Terms will be construed to limit any rights granted under
                such open-source licenses with respect to any code covered by such licenses.
                <br />
                <br />
                Subject to your acceptance of these Terms, we grant you a personal, limited, non-exclusive,
                non-sublicensable, non-transferable, revocable license to install and use the executable code version of
                the Mobile Apps. We and our licensors retain all intellectual property rights in the Mobile Apps (and
                any related Services), except for the rights we expressly grant to you in these Terms. If you breach
                these Terms, the above license and your right to use the Mobile Apps (and any related Services) will
                terminate immediately and without further notice. Upon termination, you must destroy all copies of the
                Mobile Apps that you have installed or maintained on your devices in any format.
                <br />
                <br />
                By using the Mobile Apps and related Services, you agree that we may communicate with you by email,
                notifications, or other electronic means to your mobile device for the purpose of providing and updating
                our Services.
            </p>

            <h2>App Stores</h2>
            <b>The Apple and Android App Stores are not responsible for the Mobile Apps.</b>
            <p>
                You acknowledge and agree that the availability of the Mobile Apps is dependent on the third party from
                whom you received the Mobile Apps license, e.g., the Apple iOS or Android app stores (each, an “App
                Store” and collectively, “App Stores”). The following applies to any app accessed through or downloaded
                from an App Store (“App Store Sourced Application”):
            </p>
            <ol type="a">
                <li>
                    You acknowledge and agree that (i) these Terms are concluded between you and us only, and not the
                    applicable App Store(s); and (ii) we, not the applicable App Store(s), are solely responsible for
                    the App Store Sourced Application and content thereof. Your use of the App Store Sourced Application
                    must comply with the applicable App Store’s terms of service.
                </li>
                <li>
                    You acknowledge that the applicable App Store has no obligation whatsoever to furnish any
                    maintenance and support services with respect to the App Store Sourced Application.
                </li>
                <li>
                    In the event of any failure of the App Store Sourced Application to conform to any applicable
                    warranty, you may notify the applicable App Store, and the applicable App Store will refund the
                    purchase price for the App Store Sourced Application to you and to the maximum extent permitted by
                    applicable law, the applicable App Store will have no other warranty obligation whatsoever with
                    respect to the App Store Sourced Application. As between us and the applicable App Store, any other
                    claims, losses, liabilities, damages, costs or expenses attributable to any failure to conform to
                    any warranty will be our sole responsibility.
                </li>
                <li>
                    You and we acknowledge that, as between us and the applicable App Store, the applicable App Store is
                    not responsible for addressing any claims you have or any claims of any third party relating to the
                    App Store Sourced Application or your possession and use of the App Store Sourced Application,
                    including, but not limited to (i) product liability claims; (ii) any claim that the App Store
                    Sourced Application fails to conform to any applicable legal or regulatory requirement; and (iii)
                    claims arising under consumer protection or similar legislation.
                </li>
                <li>
                    You and we acknowledge that, in the event of any third-party claim that the App Store Sourced
                    Application or your possession and use of that App Store Sourced Application infringes that third
                    party’s intellectual property rights, as between us and the applicable App Store, we, not the
                    applicable App Store, will be solely responsible for the investigation, defense, settlement and
                    discharge of any intellectual property infringement claim to the extent required by these Terms and
                    our policies.
                </li>
                <li>
                    You and we acknowledge and agree that the applicable App Store, and the applicable App Store’s
                    subsidiaries, are third party beneficiaries of these Terms as related to your license of the App
                    Store Sourced Application, and that, upon your acceptance of these Terms and conditions of these
                    Terms, the applicable App Store will have the right (and will be deemed to have accepted the right)
                    to enforce these Terms as related to your license of the App Store Sourced Application against you
                    as a third party beneficiary thereof.
                </li>
                <li>
                    Without limiting any other terms of these Terms, you must comply with all applicable third-party
                    terms of use when using the App Store Sourced Application.
                </li>
                <li>
                    n addition, for any mobile app accessed through or downloaded from the Apple iOS App Store, you will
                    only use the Apple App Store Sourced Application (i) on an Apple-branded product that runs iOS
                    (Apple’s proprietary operating system); and (ii) as permitted by the “Usage Rules” set forth in the
                    Apple iOS App Store’s Terms of Service.
                </li>
            </ol>

            <h2>Miscellaneous</h2>
            <p>
                These Terms are the entire agreement between you and us with respect to your use of our Services and
                supersede all prior or contemporaneous communications and proposals (whether oral, written or
                electronic) between you and us with respect to your use of our Services. If any provision of these Terms
                is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum
                extent necessary so that these Terms will otherwise remain in full force and effect and enforceable. The
                failure of either party to exercise in any respect any right provided for herein shall not be deemed a
                waiver of any further rights hereunder. We will not be liable for any failure to perform our obligations
                hereunder due to any cause beyond our reasonable control. These Terms are personal to you and are not
                assignable or transferable by you except with our prior written consent. We may assign, transfer or
                delegate any of our rights and obligations hereunder without consent. No agency, partnership, joint
                venture, or employment relationship is created as a result of these Terms, and neither party has any
                authority of any kind to bind the other in any respect. These Terms are governed by the laws of the
                Netherlands without reference to its choice of law rules. You irrevocably consent to exclusive personal
                jurisdiction and venue in the courts located in the Netherlands regarding any actions, claims or
                proceedings arising out of these Terms and agree not to commence or prosecute any action, claim or
                proceeding other than in those courts.
            </p>

            <h2>Contact Us</h2>
            <div
                className="contact-content"
                css={css`
                    p {
                        margin: 0;
                    }
                `}
            >
                <p>You can contact us at:</p>
                <div
                    className="contact-details"
                    css={css`
                        margin: 10px 0 0;
                    `}
                >
                    <p>Startpage</p>
                    <p>Surfboard Holding BV</p>
                    <p>Wilhelmina van Pruisenweg 104</p>
                    <p>2595 AN, Den Haag, The Netherlands</p>
                    <p>
                        Email: <a href="mailto:legal@startpage.com">legal@startpage.com</a>
                    </p>
                </div>
            </div>
            <p>
                In addition, under California Civil Code Section 1789.3, residents of California who use our Services
                are entitled to know that they may file grievances and complaints with: the Complaint Assistance Unit of
                the Division of Consumer Services of the California Department of Consumer Affairs, in writing at 400 R
                Street, Suite 1080, Sacramento, California 95814, or by telephone at (916) 445-1254 or (800) 952-5210,
                or by email at <a href="mailto:dca@dca.ca.gov">dca@dca.ca.go</a>.
            </p>

            <h2>Last updated</h2>
            <p>These Terms were last updated on April 10, 2025</p>
        </div>
    )
}

export default TermsPage
